import * as a from 'actions/livefeed/steerpathMapActions'
import update from 'immutability-helper';

export default (state, action) => {
    switch (action.type) {
        //Map
        case a.SET_MAP_CONFIG_MODE: {
            return {
                ...state,
                mapConfigMode: action.mapConfigMode
            }
        }
        case a.SET_MAP_API_KEY: {
            return update(state, {
                livefeedSlides: {
                    [action.slideCurrentIndex]: {
                        floorplanOptions: {
                            mapApiKey: { $set: action.mapApiKey }
                        }
                    }
                }
            })
        }
        case a.SET_LIVE_API_KEY: {
            return update(state, {
                livefeedSlides: {
                    [action.slideCurrentIndex]: {
                        floorplanOptions: {
                            liveApiKey: { $set: action.liveApiKey }
                        }
                    }
                }
            })
        }
        case a.SET_MAP_CONFIG: {
            return update(state, {
                livefeedSlides: {
                    [action.slideCurrentIndex]: {
                        floorplanOptions: {
                            mapConfig: { $set: action.config }
                        }
                    }
                }
            })
        }
        default: {
            return state
        }
    }
}



// WEBPACK FOOTER //
// ./src/reducers/livefeededitor/steerpathMapReducer.js